import { ChartLineUp } from "@phosphor-icons/react";

export function Logo({ compact = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <div className="flex h-9 w-9 items-center justify-center bg-primary text-primary-foreground">
        <ChartLineUp size={20} weight="bold" />
      </div>
      {!compact && (
        <div className="leading-none">
          <div className="font-heading font-extrabold tracking-tight text-[15px]">Maria's Forex / Crypto</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-0.5">Market Dashboard</div>
        </div>
      )}
    </div>
  );
}
